import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Link } from 'react-router';

interface ErrorFallbackProps {
  error: Error;
  onReset: () => void;
}

export function ErrorFallback({ error, onReset }: ErrorFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-4">
      <div className="max-w-md w-full bg-bg-elevated border border-border rounded-lg p-6 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-error/10 text-error mb-4">
          <AlertTriangle className="w-6 h-6" />
        </div>
        <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
        <p className="text-text-muted text-sm mb-4">
          The app encountered an unexpected error. You can try resetting the error
          state, or reload the page.
        </p>
        <details className="text-left mb-4 bg-bg rounded p-3 text-xs">
          <summary className="cursor-pointer text-text-muted hover:text-text mb-2">
            Error details
          </summary>
          <pre className="text-error overflow-x-auto whitespace-pre-wrap break-words">
            {error.message}
          </pre>
        </details>
        <div className="flex gap-2">
          <button
            onClick={onReset}
            className="flex-1 inline-flex items-center justify-center gap-2 py-2 px-4 bg-accent text-white rounded-lg text-sm font-medium hover:bg-accent-hover transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Reset
          </button>
          <Link
            to="/"
            onClick={onReset}
            className="flex-1 inline-flex items-center justify-center gap-2 py-2 px-4 bg-bg-hover border border-border text-text rounded-lg text-sm font-medium hover:bg-border transition-colors"
          >
            <Home className="w-4 h-4" />
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}